import type { CouponListItem } from '@tn/foundation/entities/coupon/types';
import type { ProductResponse } from '@tn/foundation/graphql/__generated/gql/graphql';

export const getProductOfferPeriod = (userPlan: ProductResponse, coupon?: CouponListItem) => {
    if (userPlan.trialInterval) {
        return userPlan.trialInterval?.toString();
    }
    if (coupon?.normalizedCoupon.isForever || coupon?.normalizedCoupon.isSingleUse) {
        return '';
    }
    return `${coupon?.normalizedCoupon.unitAmount} ${coupon?.normalizedCoupon.unit} FREE`;
};
